<script lang="ts" module>
  import { setContext, type ContextKey } from '#lib/utils/svelte-context.js';
  import { FlockRegistry } from '@typek/signalhead';
  import type { Snippet } from 'svelte';

  export const YAxisAlignmentContextKey: ContextKey<FlockRegistry<number> | undefined> =
    Symbol('YAxisAlignmentContext');
</script>

<script lang="ts">
  let { children }: { children?: Snippet } = $props();

  let commonRuler = FlockRegistry<number>();
  setContext(YAxisAlignmentContextKey, commonRuler);
</script>

{@render children?.()}
